import { Icon } from "semantic-ui-react";

import { classNames } from "utils/common";

import type { Checklist } from "models";
import type { ReactNode } from "react";

type ChecklistItemProps = {
  checklist: Checklist;
  children?: ReactNode;
  onClick?: () => void;
};

export const ChecklistItem = ({ checklist, children, onClick }: ChecklistItemProps) => (
  <div className={`ChecklistItem ${classNames({ "is-inactive": !checklist.active })}`} onClick={onClick}>
    <div className="checklist-info">
      <Icon className={checklist.dealer_id ? "warehouse" : "globe"} />
      <span className="checklist-name">{checklist.name}</span>

      {checklist.tags?.map(tag => (
        <span key={tag.id} className="checklist-tag" style={{ backgroundColor: tag.color }}>
          {tag.name}
        </span>
      ))}
    </div>

    {children && <div className="checklist-actions">{children}</div>}
  </div>
);
